export const inputTags = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true
};
export const mutableTags = {
  INPUT: true,
  TEXTAREA: true,
  OPTION: true
};
export const textInputTypes = {
  'datetime-local': true,
  'select-multiple': true,
  'select-one': true,
  color: true,
  date: true,
  datetime: true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  textarea: true,
  time: true,
  url: true,
  week: true
};